
import { createContext, useContext } from "react";
import HomeController from "./HomeController";

export interface IRootStore {
    homeController: HomeController;
}


export class BaseController implements IRootStore {
    homeController: HomeController;

    constructor() {
        this.homeController = new HomeController(this)
        console.log('homeController')
    }
}

const rootStoreContext = createContext({
    baseController: new BaseController()
})

export const useController = () => useContext(rootStoreContext)